var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { rotationVector2d, rotateDegVector2d } from "../../utils/vector.js";
import { registerPixiComponent } from "../ComponentRegistry.js";
import { F as FaceDirectionEnum } from "../../enums-86f58524.js";
import SpriteLoader from "../../loader/SpriteLoader.js";
import * as PIXI from "pixi.js";
import { PixiSpriteLoader } from "../../loader/PixiSpriteLoader.js";
import ImageLoader from "../../loader/ImageLoader.js";
import { A as AttachSchema } from "../../Attach-abbbd93e.js";
import { L as LocomotionSchema } from "../../Locomotion-379972de.js";
import { R as RadiusSchema } from "../../Radius-89a665f8.js";
import { T as TransformSchema } from "../../Transform-9450b7b5.js";
import { S as SpriteSchema } from "../../Sprite-7d2a5fa7.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../types.js";
import "../../utils/byteArray.js";
class SpriteComponentPixi {
  constructor() {
    __publicField(this, "ids", /* @__PURE__ */ new Set());
    __publicField(this, "schema", SpriteSchema);
    __publicField(this, "instances", {});
    __publicField(this, "animationCache", {});
    __publicField(this, "imageCache", {});
  }
  transform(pixiData, entity, data, gameModel, viewport) {
    const { sprite, container } = pixiData;
    const locomotionSchema = gameModel.getTypedUnsafe(entity, LocomotionSchema);
    const direction = { x: locomotionSchema.directionX, y: locomotionSchema.directionY };
    sprite.anchor.set(data.anchorX, data.anchorY);
    if (data.faceDirection === FaceDirectionEnum.ROTATE) {
      const angle = data.rotation ? rotationVector2d(rotateDegVector2d(direction, data.rotation)) : rotationVector2d(direction);
      sprite.rotation = angle;
    } else if (data.faceDirection === FaceDirectionEnum.HORIZONTAL_ROTATE) {
      const angle = data.rotation ? rotationVector2d(rotateDegVector2d(direction, data.rotation)) : rotationVector2d(direction);
      sprite.rotation = angle;
      let xDirection = direction.x;
      if (!data.rotation && gameModel.hasComponent(entity, AttachSchema)) {
        const owner = gameModel.getComponentUnsafe(entity, AttachSchema).parent;
        xDirection = LocomotionSchema.store.directionX[owner];
      }
      if (!data.antiJitterTime || gameModel.timeElapsed - pixiData.lastFlip > data.antiJitterTime) {
        if (xDirection < 0) {
          sprite.scale.x = -1;
        } else {
          sprite.scale.x = 1;
        }
        pixiData.lastFlip = gameModel.timeElapsed;
      }
    } else if (data.rotation) {
      const angle = data.rotation * Math.PI / 180;
      sprite.rotation = angle;
    } else if (data.faceDirection === FaceDirectionEnum.HORIZONTAL) {
      let xDirection = direction.x;
      if (gameModel.hasComponent(entity, AttachSchema)) {
        const owner = gameModel.getComponentUnsafe(entity, AttachSchema).parent;
        xDirection = LocomotionSchema.store.directionX[owner];
      }
      if (!data.antiJitterTime || gameModel.timeElapsed - pixiData.lastFlip > data.antiJitterTime) {
        if (xDirection < 0) {
          sprite.scale.x = -1;
        } else {
          sprite.scale.x = 1;
        }
        pixiData.lastFlip = gameModel.timeElapsed;
      }
    } else if (data.faceDirection === FaceDirectionEnum.VERTICAL) {
      if (!data.antiJitterTime || gameModel.timeElapsed - pixiData.lastFlip > data.antiJitterTime) {
        container.scale.y = direction.y < 0 ? -1 * data.scale : 1 * data.scale;
        pixiData.lastFlip = gameModel.timeElapsed;
      }
    }
    if (container.scale.x !== data.scale) {
      container.scale.set(data.scale);
    }
    const verticalDistanceFromCenter = Math.abs(pixiData.container.y - viewport.center.y);
    const horizontalDistanceFromCenter = Math.abs(pixiData.container.x - viewport.center.x);
    if (horizontalDistanceFromCenter - pixiData.container.width / 2 > 1920 || verticalDistanceFromCenter - pixiData.container.height / 2 > 1080) {
      container.visible = false;
    } else {
      container.visible = true;
    }
  }
  init(entity, gameModel, viewport) {
    var _a, _b, _c, _d, _e, _f;
    const spriteData = gameModel.getTypedUnsafe(entity, this.schema);
    let zIndex = 2;
    const instance = {
      container: ((_a = this.instances[entity]) == null ? void 0 : _a.container) ?? new PIXI.Container(),
      debug: (_b = this.instances[entity]) == null ? void 0 : _b.debug,
      lastFlip: 0
    };
    if (!instance.debug) {
      instance.debug = new PIXI.Container();
      instance.debug.visible = false;
      viewport.addChild(instance.debug);
    }
    if (spriteData.spriteKey && spriteData.currentAnimation) {
      let sprite;
      if (!((_c = this.animationCache[spriteData.currentAnimation]) == null ? void 0 : _c.length)) {
        const t = PixiSpriteLoader.getInstance().pixiSpriteLibrary.get(spriteData.spriteKey);
        sprite = new PIXI.AnimatedSprite(t.animations[spriteData.currentAnimation]);
      } else {
        sprite = this.animationCache[spriteData.currentAnimation].pop();
        sprite.visible = true;
      }
      const spriteLoaderData = SpriteLoader.getInstance().get(spriteData.spriteKey)[0];
      sprite.animationSpeed = spriteData.animationSpeed || 0.125;
      zIndex = spriteData.zIndex || spriteLoaderData.zIndex || 2;
      sprite.gotoAndPlay(spriteData.animationIndex ?? 0);
      instance.container.addChild(sprite);
      instance.sprite = sprite;
      instance.spriteKey = spriteData.currentAnimation;
    } else if (spriteData.imageKey) {
      let image;
      if (!((_d = this.imageCache[spriteData.imageKey]) == null ? void 0 : _d.length)) {
        const imageTexture = ImageLoader.getInstance().getPixiTexture(spriteData.imageKey);
        image = new PIXI.Sprite(imageTexture);
      } else {
        image = this.imageCache[spriteData.imageKey].pop();
        image.visible = true;
      }
      const imageLoaderData = ImageLoader.getInstance().get(spriteData.imageKey);
      instance.container.addChild(image);
      zIndex = spriteData.zIndex || imageLoaderData.zIndex || 2;
      instance.sprite = image;
      instance.spriteKey = spriteData.imageKey;
    } else {
      let sprite;
      if (!((_e = this.animationCache[spriteData.spriteKey]) == null ? void 0 : _e.length)) {
        const t = PixiSpriteLoader.getInstance().pixiSpriteLibrary.get(spriteData.spriteKey);
        sprite = new PIXI.AnimatedSprite(t.animations[spriteData.spriteKey]);
      } else {
        sprite = this.animationCache[spriteData.spriteKey].pop();
        sprite.visible = true;
      }
      const spriteLoaderData = SpriteLoader.getInstance().get(spriteData.spriteKey)[0];
      sprite.animationSpeed = 0.125;
      zIndex = spriteData.zIndex || spriteLoaderData.zIndex || 2;
      sprite.gotoAndStop(spriteData.frame);
      instance.container.addChild(sprite);
      instance.sprite = sprite;
      instance.spriteKey = spriteData.spriteKey;
    }
    instance.container.zIndex = zIndex;
    instance.sprite.position.set(0, 0);
    (_f = instance.container) == null ? void 0 : _f.scale.set(spriteData.scale);
    this.instances[entity] = instance;
    viewport.addChild(instance.container);
    this.ids.add(entity);
  }
  run(entity, gameModel, viewport) {
    const spriteData = gameModel.getTypedUnsafe(entity, this.schema);
    if (this.instances[entity] && (spriteData.currentAnimation ?? spriteData.imageKey ?? spriteData.spriteKey) !== this.instances[entity].spriteKey) {
      this.cleanup(entity, gameModel);
    }
    if (!this.instances[entity]) {
      this.init(entity, gameModel, viewport);
    }
    const pixiData = this.instances[entity];
    const { sprite, container, debug } = pixiData;
    if (spriteData.opacity === 0) {
      sprite.visible = false;
    } else {
      sprite.visible = true;
      sprite.alpha = spriteData.opacity ?? 1;
    }
    const transformSchema = gameModel.getTypedUnsafe(entity, TransformSchema);
    const position = transformSchema.position;
    position.y -= transformSchema.z;
    let xoffset = 0;
    let yoffset = 0;
    if (spriteData.imageKey) {
      const imageLoaderData = ImageLoader.getInstance().get(spriteData.imageKey);
      xoffset = spriteData.xoffset ?? imageLoaderData.xoffset;
      yoffset = spriteData.yoffset ?? imageLoaderData.yoffset;
    } else {
      const spriteLoaderData = SpriteLoader.getInstance().get(spriteData.spriteKey)[0];
      xoffset = spriteData.xoffset ?? spriteLoaderData.xoffset;
      yoffset = spriteData.yoffset ?? spriteLoaderData.yoffset;
      if (!spriteData.currentAnimation) {
        const animatedSprite = sprite;
        if (animatedSprite.currentFrame !== spriteData.frame) {
          animatedSprite.gotoAndStop(spriteData.frame);
        }
      }
    }
    const viewY = viewport.position.y;
    if (spriteData.inheritParentZIndex && gameModel.hasComponent(entity, AttachSchema)) {
      const owner = gameModel.getComponentUnsafe(entity, AttachSchema).parent;
      container.zIndex = TransformSchema.store.y[owner] - viewY + TransformSchema.store.z[owner] + RadiusSchema.store.radius[owner] + spriteData.zIndex;
    } else if (spriteData.relativeZIndex) {
      container.zIndex = TransformSchema.store.y[entity] - viewY + TransformSchema.store.z[entity] + RadiusSchema.store.radius[entity] + spriteData.zIndex;
    } else {
      container.zIndex = spriteData.zIndex;
    }
    container.x = position.x + xoffset;
    container.y = position.y + yoffset;
    debug == null ? void 0 : debug.position.set(position.x, position.y);
    this.transform(pixiData, entity, spriteData, gameModel, viewport);
  }
  cleanup(entity, gameModel) {
    const instanceData = this.instances[entity];
    if (!instanceData) {
      return;
    }
    instanceData.container.destroy();
    const instance = this.instances[entity].sprite;
    delete this.instances[entity];
    instance.visible = false;
    const spriteData = gameModel.getTypedUnsafe(entity, this.schema);
    if (spriteData.spriteKey) {
      const key = instanceData.spriteKey;
      this.animationCache[key] = this.animationCache[key] ?? [];
      this.animationCache[key].push(instance);
    } else {
      this.imageCache[instanceData.spriteKey] = this.imageCache[instanceData.spriteKey] ?? [];
      this.imageCache[instanceData.spriteKey].push(instance);
    }
    this.ids.delete(entity);
  }
}
registerPixiComponent("Sprite", SpriteComponentPixi);
export {
  SpriteComponentPixi
};
//# sourceMappingURL=Sprite.js.map
